module.exports = __webpack_public_path__ + "img/bicm.7ec8eebe.png";